import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ContactSupport"] */ "/vercel/path0/components/ContactSupport/ContactSupport.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactSupportUrlSync"] */ "/vercel/path0/components/ContactSupport/ContactSupportUrlSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoDayStats"] */ "/vercel/path0/components/core/DemoDayStats/DemoDayStats.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthBox"] */ "/vercel/path0/components/core/login/components/AuthBox/AuthBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthInfo"] */ "/vercel/path0/components/core/login/components/AuthInfo/AuthInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BroadcastChannel","createLogoutChannel","logoutAllTabs","broadcastLogout"] */ "/vercel/path0/components/core/login/components/BroadcastChannel/BroadcastChannel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieChecker"] */ "/vercel/path0/components/core/login/components/CookieChecker/CookieChecker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthInvalidUser"] */ "/vercel/path0/components/core/login/components/modals/AuthInvalidUser/AuthInvalidUser.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/login/components/modals/LinkAccountModal/LinkAccountModal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/login/components/PrivyModals/PrivyModals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfoChecker"] */ "/vercel/path0/components/core/login/components/UserInfoChecker/UserInfoChecker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfoValidator"] */ "/vercel/path0/components/core/login/components/UserInfoValidator/UserInfoValidator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/MobileBottomNav/MobileBottomNav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/MobileBottomNav/useScrollDirection.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/navbar/components/CompleteYourProfile/CompleteYourProfile.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/navbar/components/PlaaBanner/PlaaBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/navbar/components/SubscribeToRecoomendations/SubscribeToRecoomendations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/core/navbar/nav-bar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/office-hours-rating/rating-container.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/register/member-register-dialog.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/core/ToastContainer/components/Toast/Toast.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/core/ToastContainer/ToastContainer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/page/forum/Post/Post.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/page/onboarding/components/LoginFlowTrigger/LoginFlowTrigger.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/page/onboarding/components/OnboardingFlowTrigger/OnboardingFlowTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/page/posthog-identifier.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/page/recommendations/components/RecommendationsPreloader/PostLoginRedirectHandler.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/vercel/path0/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast"] */ "/vercel/path0/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/providers/analytics-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PushNotificationsContext"] */ "/vercel/path0/providers/PushNotificationsProvider/PushNotificationsContext.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/providers/PushNotificationsProvider/PushNotificationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/providers/registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/providers/StoreInitializer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/index.scss");
